const APIS = {
  BRANCH: "/usermanagementservice/api/branch/",
  STAFF: "/usermanagementservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  USER_PROFILE: "logisticservice/api/user-profile/",
  DRIVER: "/fleetservice/api/driver/",
  CONTACT_GROUP: "/contactservice/api/contact-groups/",
  SYNC_CONTACT: "/contactservice/api/contact-groups/sync/",
  CHANGE_PASSWORD: "/usermanagementservice/api/user/set-password/",
};

export default APIS;
